import { z } from "zod";
import type { SchemaConfig, FieldMetaMap } from "@/lib/form-v2";

export const QUEUE_TYPE = "queue" as const;

export const QueueFormShape = z.object({
  queue_type: z.literal(QUEUE_TYPE),
  max_concurrent: z.number().int().min(0).max(20).nullable(),
});

export type QueueFormValues = z.infer<typeof QueueFormShape>;

export const queueSchemaConfig: SchemaConfig = {
  discriminatorField: "queue_type",
  base: QueueFormShape as z.ZodObject<z.ZodRawShape>,
  variants: {
    [QUEUE_TYPE]: QueueFormShape as z.ZodObject<z.ZodRawShape>,
  },
  validators: {
    [QUEUE_TYPE]: QueueFormShape,
  },
  defaultVariantKey: QUEUE_TYPE,
};

export function buildFieldMeta(): FieldMetaMap<QueueFormValues> {
  return {
    queue_type: {
      label: "Type",
      widget: "text",
      visible: () => false,
    },
    max_concurrent: {
      label: "Max Concurrent",
      widget: "int",
      placeholder: "Enter 0-20 or leave empty for null",
    },
  };
}

export const defaultFormValues: QueueFormValues = {
  queue_type: QUEUE_TYPE,
  max_concurrent: null,
};
